import { useEffect, useRef } from "react"
import { createPortal } from "react-dom"
import mapboxgl from 'mapbox-gl'

const PopupOTB = ({ map, activeFeature }) => {

  // a ref to hold the popup instance
  const popupRef = useRef()
  // a ref for an element to hold the popup's content
  const contentRef = useRef(document.createElement("div"))

  // instantiate the popup on mount, remove it on unmount
  useEffect(() => {
    if (!map) return

    // create a new popup instance, but do not set its location or content yet
    popupRef.current = new mapboxgl.Popup({
      closeOnClick: false,
      offset: 20
    })

    return () => {
      popupRef.current.remove()
    }
  }, [])


  // when activeFeature changes, set the popup's location and content, and add it to the map
  useEffect(() => {
    if (!activeFeature) return

    popupRef.current
      .setLngLat(activeFeature.geometry.coordinates) // set its position using activeFeature's geometry
      .setHTML(contentRef.current.outerHTML) // use contentRef's `outerHTML` to set the content of the popup
      .addTo(map) // add the popup to the map
  }, [activeFeature])

  // use a react portal to render the content to show in the popup, assigning it to contentRef
  return (
    <>{
      createPortal(
        <div className="portal-content">
          <table>
            <tbody>
              
              <tr>
                <td><strong>OTB</strong></td>
                <td style={{marginLeft:".5rem"}}>{activeFeature?.properties.texto}</td>
              </tr>
              {activeFeature?.properties.texto && activeFeature?.properties.Libre?
              <tr>
                <td><strong>Libre</strong></td>
                <td style={{marginLeft:".5rem"}}>{activeFeature?.properties.Libre}</td>
              </tr>
              :null}
              {activeFeature?.properties.texto && activeFeature?.properties.Pdc?
              <tr>
                <td><strong>PDC</strong></td>
                <td style={{marginLeft:".5rem"}}>{activeFeature?.properties.Pdc}</td>
              </tr>
              :null}
              {activeFeature?.properties.texto && activeFeature?.properties.Ap?
              <tr>
                <td><strong>AP</strong></td>
                <td style={{marginLeft:".5rem"}}>{activeFeature?.properties.Ap}</td>
              </tr>
              :null}
              {activeFeature?.properties.texto && activeFeature?.properties.Apb?
              <tr>
                <td><strong>APB</strong></td>
                <td style={{marginLeft:".5rem"}}>{activeFeature?.properties.Apb}</td>
              </tr>
              :null}
              {activeFeature?.properties.texto && activeFeature?.properties.Fp?
              <tr>
                <td><strong>FP</strong></td>
                <td style={{marginLeft:".5rem"}}>{activeFeature?.properties.Fp}</td>
              </tr>
              :null}
              {activeFeature?.properties.texto && activeFeature?.properties.Lyp?
              <tr>
                <td><strong>LYP</strong></td>
                <td style={{marginLeft:".5rem"}}>{activeFeature?.properties.Lyp}</td>
              </tr>
              :null}
              {activeFeature?.properties.texto && activeFeature?.properties.Mas?
              <tr>
                <td><strong>MAS</strong></td>
                <td style={{marginLeft:".5rem"}}>{activeFeature?.properties.Mas}</td>
              </tr>
              :null}              
              {activeFeature?.properties.texto && activeFeature?.properties.Unidad?
              <tr>
                <td><strong>Unidad</strong></td>
                <td style={{marginLeft:".5rem"}}>{activeFeature?.properties.Unidad}</td>
              </tr>
              :null}
              {/* <tr>
                <td><strong>Place</strong></td>
                <td></td>
              </tr> */}
            </tbody>
          </table>
        </div>,
        contentRef.current
      )
    }</>
  )
}

export default PopupOTB